import styled from 'styled-components';

export const StyledMockUserNavDiv = styled.div`
  padding: 6px;
  border-bottom: 2px solid black;
  background-color: #f2af34;
  position: relative;
  width: 100%;
`;
